import { flexRow, media } from '@anm/styles/helpers';
import styled from 'styled-components';

const wrapperOnMobile = media.phone`
	margin-top: 11px;
`;

const Wrapper = styled.div`
  ${flexRow};
  &:empty {
    display: none;
  }
  & > * {
    margin-right: 16px;
  }
  ${wrapperOnMobile};
`;

export default Wrapper;
